import { initializeStore } from '@/utils/vuex-api-utils';
import uploadsModule from '@/store/modules/uploads-module';
import bankingModule from '@/store/modules/banking-module';
import contractsModule from '@/store/modules/contracts-module';
import connectedAccountsModule from '@/store/modules/connected-accounts-module';
import vendorModule from '@/store/modules/vendor-module';
import cardsModule from '@/store/modules/cards-module';
import externalAccountsModule from '@/store/modules/external-accounts-module';
import profileModule from '@/store/modules/profile-module';
import accountingModule from '@/store/modules/accounting-module';
import userSettingsModule from '@/store/modules/user-settings-module';
import plaidWhitelistModule from '@/store/modules/plaid-whitelist-module';
import plaidProxyModule from '@/store/modules/plaid-proxy-module';
import heronPdfModule from '@/store/modules/heron-pdf-module';
import debtObligationsModule from '@/store/modules/debt-obligations-module';
import trackingModule from '@/store/modules/tracking-module';
import fundingInquiriesModule from '@/store/modules/funding-inquiries-module';
import verificationsModule from './modules/verifications-module';

import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import signupModule from './modules/signup-module';
import onboardingModule from './modules/onboarding-module';
import manualReadOnlyAccountsModule from './modules/manual-read-only-accounts-module';
import todoSectionModule from './modules/todo-section-module';
import paymentsOnboardingModule from './modules/payments-module';
import experimentsModule from './modules/experiments-module';
import productsModule from './modules/products-module';
import { isProduction } from '../../config/app-env';

const initialState = {
  // initialize an object to track request state for each api related action
  advances: {},
  adjudication: null,
  // used only to trigger the signup popup with some initial info
  signupStart: {
    triggeredAt: null,
    businessType: null,
    phone: null,
    email: null,
    businessAgeRange: null,
  },
  ecomRevenue: {},
  advanceFeesInfo: null,
  autocompleteEnabled: {},
  currentStateModule: '',
  showLegacyModal: false,
};

const store = initializeStore({
  state: initialState,
  actions,
  getters,
  mutations,
  modules: {
    uploads: uploadsModule,
    banking: bankingModule,
    contracts: contractsModule,
    connectedAccounts: connectedAccountsModule,
    vendor: vendorModule,
    cards: cardsModule,
    externalAccounts: externalAccountsModule,
    profile: profileModule,
    accounting: accountingModule,
    signup: signupModule,
    onboarding: onboardingModule,
    userSettings: userSettingsModule,
    manualReadOnlyAccounts: manualReadOnlyAccountsModule,
    todoSections: todoSectionModule,
    paymentsOnboarding: paymentsOnboardingModule,
    experiments: experimentsModule,
    products: productsModule,
    plaidWhitelist: plaidWhitelistModule,
    plaidProxy: plaidProxyModule,
    heronPdf: heronPdfModule,
    debtObligations: debtObligationsModule,
    tracking: trackingModule,
    fundingInquiries: fundingInquiriesModule,
    verifications: verificationsModule,
  },
  strict: !isProduction,
});
window.store = store;

export default store;
